import React from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';

// ErrorMessage
// Display a messsage to the user
// Option to set the message to red by flagging it as 'error'
function ErrorMessage({ message, error }) {
  const classes = classNames('message', {
    'message--error': error,
  });

  return (
    <CSSTransition
      in={true}
      appear
      key={message}
      timeout={400}
      classNames="error"
    >
      <div className={classes}>
        {error && (
          <i className="message__error-icon">
            <ReactSVG src="images/icons/error.svg" />
          </i>
        )}
        {message}
      </div>
    </CSSTransition>
  );
}

export default ErrorMessage;
